import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';
import { GenerationNoiseLightingBlock } from '../../report/GenerationImpactProjectionBlocks';

export const NoiseVisualImpactSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.noiseVisualImpact;
  const hasPromotedScenario = !!report.generationImpactProjection?.environmentalAndCommunity;
  const hasData = hasPromotedScenario || (!!data && !!(data.constructionNoise || data.operationalNoise || data.visualScreening));
  return (
    <SectionShell label={label} hasData={hasData} report={report}>
      <GenerationNoiseLightingBlock report={report} />
      {data?.constructionNoise && <EditorialSubsection theme={theme} label="Construction Noise">{data.constructionNoise}</EditorialSubsection>}
      {data?.operationalNoise && <EditorialSubsection theme={theme} label="Operational Noise">{data.operationalNoise}</EditorialSubsection>}
      {data?.visualScreening && <EditorialSubsection theme={theme} label="Visual Screening">{data.visualScreening}</EditorialSubsection>}
    </SectionShell>
  );
};
